import axios from 'utils/axios';

const API_URL = 'rubric';

export interface RubricLevelDTO {
  levelName: string;
  scorePercent: number;
}

export type RubricUserRef = {
  firstName?: string;
  lastName?: string;
  email?: string;
  type?: string;
};

export interface RubricDTO {
  _id?: string;
  name?: string;
  levels: RubricLevelDTO[];
  created_at?: string;
  updated_at?: string;
  createdBy?: RubricUserRef | string;
  assessorId?: RubricUserRef | string;
}

export interface GetRubricsParams {
  page?: number;
  limit?: number;
  sortColumn?: string;
  sortOrder?: 'asc' | 'desc';
  search?: string;
  /** When set with assessmentSessionId, returns rubrics linked to that session’s questions (for marks entry). */
  batchId?: string;
  assessmentSessionId?: string;
}

export const getRubrics = async (params?: GetRubricsParams) => {
  return await axios.get(API_URL + '', { params });
};

export const getRubricById = async (id: string) => {
  return await axios.get(`${API_URL}/${id}`);
};

export const createRubric = async (data: { name?: string; levels: RubricLevelDTO[] }) => {
  return await axios.post(API_URL + '', data);
};

export const updateRubric = async (id: string, data: { name?: string; levels: RubricLevelDTO[] }) => {
  return await axios.put(`${API_URL}/${id}`, data);
};

export const deleteRubric = async (id: string) => {
  return await axios.delete(`${API_URL}/${id}`);
};

